import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\ProfileController::__invoke
* @see app/Http/Controllers/Investors/ProfileController.php:21
* @route '//app.finesthub.de/profile'
*/
const ProfileController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProfileController.url(options),
    method: 'get',
})

ProfileController.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/profile',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\ProfileController::__invoke
* @see app/Http/Controllers/Investors/ProfileController.php:21
* @route '//app.finesthub.de/profile'
*/
ProfileController.url = (options?: RouteQueryOptions) => {
    return ProfileController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\ProfileController::__invoke
* @see app/Http/Controllers/Investors/ProfileController.php:21
* @route '//app.finesthub.de/profile'
*/
ProfileController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProfileController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\ProfileController::__invoke
* @see app/Http/Controllers/Investors/ProfileController.php:21
* @route '//app.finesthub.de/profile'
*/
ProfileController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ProfileController.url(options),
    method: 'head',
})

export default ProfileController